<template>
    <div class="login-page">
      <div class="admin-link">
        <a href="#" class="admin-text">代理端</a>
      </div>
      <div class="login-box">
        <div class="logo-section">
          <!-- 替换 src 为你的 logo 图片地址 -->
          <img class="logo-img" :src="require('@/assets/images/登录logo.png')" alt="logo" />
          <!-- <div class="logo-title">
            <div class="main-title">声瀚网络科技</div>
            <div class="sub-title">SHENGHAN NETWORK TECHNOLOGY</div>
          </div> -->
        </div>
        <el-form :model="loginForm" class="login-form">
          <p>【<span style="color: #6797ff;">{{ userInfo.nick_name }}</span>】您的代理资格已到期 账号剩余【<span style="color:#6797ff">{{ userInfo.recharge_amount }}元</span>】</p>
          <p> 如有需要请在微信公众号【声瀚】内联系企业微信客服 </p>
          <p> 进行续约代理资格或使用余额 </p>
        </el-form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginPage',
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loading: false,
        userInfo: {},
      }
    },
    created(){
      const userInfoStr = this.$route.query.userInfo
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr)
        console.log('接收到的 userInfo:', this.userInfo)
      }
    },
    methods: {
     
    }
  }
  </script>
  
  <style scoped>
  .login-page {
    width: 100vw;
    height: 100vh;
    background: #fff;
    position: relative;
  }
  
  .admin-link {
    position: absolute;
    top: 20px;
    right: 40px;
  }
  
  .admin-text {
    color: #3BB2FF;
    font-size: 14px;
    text-decoration: none;
  }
  
  .login-box {
    width: 400px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    right: 0;
    top: 18%;
  }
  
  .logo-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }
  
  .logo-img {
    
    margin-right: 16px;
    object-fit: contain;
  }
  
  .logo-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .main-title {
    font-size: 38px;
    font-weight: bold;
    color: #222;
    letter-spacing: 2px;
    margin-bottom: 2px;
    font-family: '微软雅黑', 'Microsoft YaHei', Arial, sans-serif;
  }
  
  .sub-title {
    font-size: 16px;
    color: #222;
    letter-spacing: 2px;
    font-family: 'Roboto', Arial, sans-serif;
  }
  
  .login-form {
    margin-top: 10px;
  }
  
  .el-input__inner {
    background: #f8f8f8;
    border: none;
    height: 44px;
    font-size: 16px;
    color: #222;
  }
  
  .el-form-item {
    margin-bottom: 14px;
  }
  
  .login-btn {
    width: 100%;
    height: 40px;
    background: #C5ECFF !important;
    border-radius: 20px;
    color: #fff;
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 600;
    border: none;
    transition: background .2s;
  }
  
  .login-btn:active,
  .login-btn:focus {
    background: #A2DBFF !important;
    color: #fff;
  }
  
  ::v-deep .el-input__prefix {
    color: #bdbdbd;
  }
  </style>